// extracted by mini-css-extract-plugin
module.exports = {"Feature":"feature-module--Feature--2SDUj","Icon":"feature-module--Icon--ncwh2"};